import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  Alert,
  Button,
  CardImg,
} from 'reactstrap';
import Breadcrumbs from "components/Common/Breadcrumb";
import { fetchListBacaan, handleViewFile } from '../../../services/bacaanService';
import {
  FiAlertCircle,
  FiArrowRight,
  FiBookOpen,
} from 'react-icons/fi';

const ListBacaan = () => {
  const [bacaanList, setBacaanList] = useState([]);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentParentName, setCurrentParentName] = useState('MATERI BACAAN');

  const pageTitle = "MATERI BACAAN";

  useEffect(() => {
    document.title = `${currentParentName} | Kumpulan ${pageTitle}`;
  }, [pageTitle, currentParentName]);

  const getImageUrl = useCallback((filePath) => {
    if (!filePath) {
      return '/images/default-material.png';
    }
    if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
      return filePath;
    }
    return `${process.env.REACT_APP_API_BASE_URL || ''}${filePath.startsWith('/') ? '' : '/'}${filePath}`;
  }, []);

  const fetchBacaanList = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const params = new URLSearchParams(location.search);
      const id_jenis_soal = params.get('id_jenis_soal');
      const id_jenis_seleksi = params.get('id_jenis_seleksi');
      const id_kategori_paket = params.get('id_kategori_paket');
      const id_tipe_konten = params.get('id_tipe_konten');
      const kategoriFromUrl = params.get('kategori');

      setCurrentParentName(kategoriFromUrl ? kategoriFromUrl.toUpperCase() : 'MATERI BACAAN');

      const response = await fetchListBacaan({
        id_jenis_soal,
        id_jenis_seleksi,
        id_kategori_paket,
        id_tipe_konten,
        disable_pagination: true,
      });

      if (response.success && Array.isArray(response.data)) {
        setBacaanList(response.data);
      } else {
        setError(response.message || 'Data bacaan kosong atau tidak valid.');
      }
    } catch (err) {
      setError(err.message || 'Gagal memuat bacaan.');
    } finally {
      setLoading(false);
    }
  }, [location.search]);

  useEffect(() => {
    fetchBacaanList();
  }, [fetchBacaanList]);

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Materi Bacaan" breadcrumbItem={pageTitle} />
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
            <Spinner color="primary" />
            <span className="ms-2">Memuat materi bacaan...</span>
          </div>
        </Container>
      </div>
    );
  }

  if (error) {
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Materi Bacaan" breadcrumbItem={pageTitle} />
        <Alert color="danger">
          <FiAlertCircle className="me-2" size={18} />
          {error}
        </Alert>
      </Container>
    </div>
  );
}

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Materi Bacaan" breadcrumbItem={currentParentName} />

        {bacaanList.length === 0 ? (
          <Alert color="info" className="text-center py-3">
            Tidak ditemukan materi bacaan.
          </Alert>
        ) : (
          <Row className="gy-4">
            {bacaanList.map((item, index) => {
              const imageUrl = getImageUrl(item.thumbnail_image);

              return (
                <Col key={index}  lg={3} md={3}>
                  <Card className="materi-card h-100" style={{ cursor: 'pointer' }}>
                    <div className="materi-image-container">
                      {imageUrl ? (
                        <CardImg
                          top
                          src={imageUrl}
                          alt={item.judul}
                          onError={(e) => {
                            e.target.src = '/images/default-material.png';
                            e.target.className = 'materi-image-fallback';
                          }}
                          className="materi-image"
                        />
                      ) : (
                        <div className="materi-image-placeholder">
                          <FiBookOpen size={48} className="text-muted" />
                          <p className="mt-2 text-muted">No Image</p>
                        </div>
                      )}
                    </div>
                    <CardBody className="text-center">
                      <h5 className="materi-title mb-2">{item.judul}</h5>
                      <div
                        className="materi-desc text-muted small mb-3"
                        dangerouslySetInnerHTML={{ __html: item.deskripsi || 'Deskripsi tidak tersedia' }}
                      />
                 
                    <Button   color="primary"
                        outline
                        className="w-75 materi-btn" onClick={() => handleViewFile(item.file_bacaan)} >
                       Baca Disini
                    </Button>
                    </CardBody>
                  </Card>
                </Col>
              );
            })}
          </Row>
        )}
      </Container>
    </div>
  );
};

export default ListBacaan;
